import React from 'react'
import { Text, View } from 'react-native'

/** Separate glyphs keep the arrow from consuming the label's right padding. */
export function FortifyButtonLabel({ fontSize }: { fontSize?: number }) {
  return <View className="flex-row items-center" style={{ gap: 6 }}>
    <Text className="text-paper text-xs font-stencil uppercase" style={{ fontSize }}>Fortify</Text>
    <Text className="text-paper text-xs font-stencil" style={{ fontSize }}>→</Text>
  </View>
}
